<template>
  <div>
    <NavBar />
    <div class="container">
      <h1>404: Not found</h1>
    </div>
  </div>
</template>

<script>
import NavBar from "@/views/reports/NavBar.vue";

export default {
  components: {
    NavBar,
  },
};
</script>
